// forms
// route page
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LoginUser } from 'src/app/models/login-user';
import { UserService } from '../../../../services/user_V2.service';
import { ApiResponse } from 'src/app/models/api-response';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { AppConfigService } from '../../../../app-config.service.service';
import { Routes, RouterModule, Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormControl } from '@angular/forms';
import { CompanySettingsService } from 'src/app/services/company-settings.service';
import { MapInformationService } from 'src/app/services/map-information.service';
import { ThemeService } from 'src/app/services/theme.service'
import { VariablesService } from 'src/app/services/variables.service'

@Component({
    selector: 'app-login',
    templateUrl: './login-cubeshop.component.html',
    styleUrls: ['./login-cubeshop.component.scss'],
    standalone: false
})

export class LoginCubeShopComponent implements OnInit, OnDestroy {
  @ViewChild('uploader', { static: true })
  uploader: any;
  optionCompanysSelect: Array<any>;
  cardForm: UntypedFormGroup;
  submitted = false;
  isLoading = false;
  msgError: string;
  showError = false;
  file: File | null;
  apiBaseUrl: string;
  ecomerceconcode: string;
  showPassword = false;
  typeInputPassword = 'password';
  settings: string;

  dumLoginUser: LoginUser;
  base64Logo: string = 'assets/cube-logo.png';
  hasCompanyLogo = false; // true si la URL trae logo propio de la empresa (white-label)
  capsOn = false;        // aviso de Bloq Mayus en el password
  // slider del panel de marca: el avance lo dispara el (animationend) del indicador activo
  slides = ['Dashboard', 'Service work orders', 'Service sites & assets'];
  slideIdx = 0;
  slidesPaused = false;

  constructor(private formBuilder: UntypedFormBuilder, private router: Router, private http: HttpClient,
    private userService: UserService, private appConfigService: AppConfigService, private activatedRoute: ActivatedRoute,
    public settingsCompany: CompanySettingsService,
    public apiConfig: AppConfigService,
    private route: ActivatedRoute, public ThemeService: ThemeService,
    public VariablesService: VariablesService, public MapInformationService: MapInformationService,
    private meta: Meta) {


    this.settings = localStorage.getItem('settings');

    if (!this.settings || this.settings == 'null')
      this.settings = null;

  }

  ngOnDestroy() {
    this.meta.removeTag("name='robots'");
  }

  ngOnInit() {
    this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow' });

    this.ThemeService.setNavaBar('navbar-disabled')

    var autoStart = localStorage.getItem('autoStart');

    sessionStorage.clear();
    localStorage.clear();


    this.cardForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    });

    this.apiBaseUrl = this.appConfigService.apiBaseUrl;

    if(this.appConfigService.env_dev !== undefined && this.appConfigService.env_dev !== null && this.appConfigService.env_dev === true){
      this.ecomerceconcode = "02978EBB5E"
      return;
    }

    const result = this.getCurrentUrl();

    if (!environment.production) {
      console.log("🚀 ~ LoginV2Component ~ ngOnInit ~ result:", result)
    }

    let info = {
      method: "Get_CompanyCodeFromURL",
      connectioncode:"cube",
      url: result[0],
    }

    this.MapInformationService.GetCompanySettings(info).subscribe(resp => {
      let data = resp[0]
      let tipo = ""
      switch (data.filestring.toUpperCase()) {
        case "/9J/4": tipo = "jpeg";
          break
        default:
          tipo = "png"
          break
        }

        if (data.filestring != '' && data.filestring != undefined) {
          this.base64Logo = 'data:image/' + tipo + ';base64,' + data.filestring;
          this.hasCompanyLogo = true;
        } else {
         /*  this.base64Logo = ''
          console.log("No hay logo") */
        }

        this.ecomerceconcode = data.companycode
        this.ThemeService.setEcomerceconcode(this.ecomerceconcode)
        this.ThemeService.setImgLogo(this.base64Logo)
    }, () => {
      // Error loading company settings (e.g. URL not found in DB).
      // Silenced in production to avoid exposing internal API paths in the browser console.
      if (!environment.production) {
        console.warn('Could not load company settings for this URL.');
      }
    })


  
    // this.ecomerceconcode = this.appConfigService.ecomerceconcode;


    this.optionCompanysSelect = [
      { value: '1', label: 'Amazing Control' },
      { value: '2', label: 'CUBE-USA' },
      { value: '3', label: 'South Florida Control' },
      { value: '4', label: 'Template Company' },
      { value: '5', label: 'Travis Brothers' },
    ];

  }

  goToSlide(i: number) { this.slideIdx = i; }
  nextSlide() { this.slideIdx = (this.slideIdx + 1) % this.slides.length; }
  pauseSlides(p: boolean) { this.slidesPaused = p; }

  onPasswordKey(ev: KeyboardEvent) {
    this.capsOn = !!(ev && ev.getModifierState && ev.getModifierState('CapsLock'));
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
    this.typeInputPassword = this.showPassword ? 'text' : 'password';
  }


  onSubmit() {
    // validacion en cliente + estado de carga en el boton (antes se llamaba al SP con los campos vacios)
    this.showError = false;
    this.msgError = '';
    this.submitted = true;
    if (this.cardForm.invalid) {
      return 0;
    }
    this.isLoading = true;

    this.userService.Get_CubeShopLogin({Email: this.cardForm.value.username, Password: this.cardForm.value.password, ConnCode: this.ecomerceconcode}).subscribe(result =>  {
      this.isLoading = false;
      if (result.connected) {
        // SECURITY NOTE: Storing the JWT in localStorage exposes it to XSS attacks.
        // Full remediation requires the backend to issue the token via a Set-Cookie header
        // with httpOnly, Secure, and SameSite=Strict attributes.
        // Tracked in SECURITY_AUDIT.md #5.
        localStorage.setItem('token', result.token);
        localStorage.setItem('userName', result.userName);
        localStorage.setItem('userID', result.userID);
        localStorage.setItem('customerid', result.customerID);
        localStorage.setItem('email', this.cardForm.value.username);
        // SECURITY: Store only the minimum non-sensitive fields needed by the UI.
        // The full result object (which may contain roles, permissions, and other
        // sensitive data) must not be persisted in localStorage.
        localStorage.setItem('userData', JSON.stringify({
          userName: result.userName,
          userID: result.userID,
          connected: result.connected,
          customerID: result.customerID
        }));
        this.ThemeService.setNavaBar('navbar-active')
        this.VariablesService.setUserName(result.userName)
        this.router.navigateByUrl('/cs-portal');
      }
      else {
        this.showError = true;
        this.msgError = 'Invalid username or password';
      }
    }, () => {
      this.isLoading = false;
      this.showError = true;
      this.msgError = 'Server internal error, please contact the administrator!';
    })

    return 0;
    

    this.showError = false;
    this.msgError = '';
    this.submitted = true;
    // stop here if form is invalid
    if (this.cardForm.invalid) {
      return;
    }
    this.isLoading = true;
    let value = this.cardForm.value;
    this.userService.login(value).subscribe((data: ApiResponse) => {
      if (data.connected) {
        localStorage.clear();

        if (this.settings)
        localStorage.setItem('settings', this.settings);
        localStorage.setItem('termaccepted', data.termAccepted.toString());
        localStorage.setItem('token', data.token);
        localStorage.setItem('userName', data.userName);
        localStorage.setItem('isClient', data.isClient);
        localStorage.setItem('customerid', data.customerID);
        localStorage.setItem('email', value.username);
        localStorage.setItem('currentLat', data.lat);
        localStorage.setItem('currentLong', data.long);
        localStorage.setItem('ubicacion', data.ubicacion);
        this.userService.currentUserName.next(data.userName);
        this.userService.isClient.next(JSON.parse(data.isClient.toLocaleLowerCase()));

        if (data.customerID) {
          this.userService.Get_UserSettingsCE(data.customerID).subscribe(result => {

            if (result.length > 0 && result[0].CLIENTUSERSETTING) {
              let obj = JSON.parse(result[0].CLIENTUSERSETTING);
              obj.regionid = result.RegionID;

              localStorage.setItem('settings', JSON.stringify(obj));
              localStorage.setItem('UserCompanyName', result[0].UserCompanyName);

              // This code detect boostrap screen standar resolution. Its used to start always
              // with home page if its mobile screen *************************
              const width = Math.max(
                document.documentElement.clientWidth,
                window.innerWidth || 0
              )
              var screenType = 'xl';
              if (width <= 576) { screenType = 'xs' }
              if (width <= 768) { screenType = 'sm' }
              if (width <= 992) { screenType = 'md' }
              if (width <= 1200) { screenType = 'lg' }
              var ignoreStartPage = false;
              if (screenType == 'xs' || screenType == 'sm') { ignoreStartPage = true }


              this.userService.settings.next(obj);

              this.userService.settings.next(obj);

              let goto = obj.startPage && !ignoreStartPage ? obj.startPage : '/home';
              this.router.navigateByUrl(goto);
            } else {
              this.router.navigateByUrl('/home');
            }
          }, err => {
            this.router.navigateByUrl('/home');
          }
          );
        }


        // this.router.navigateByUrl('/home');
      } else {
        this.showError = true;
        this.msgError = 'Invalid username or password';
      }
    }, error => {
      this.showError = true;
      this.msgError = 'Server internal error, please contact the administrator!';
    });
    this.submitted = false;
    this.isLoading = false;
  }
  gotoEstimate() {
  }
  public myDatePickerOptions: any = {
    // Your options
  }

  getCurrentUrl(): string[] {
    // Use hostname (no port, no path) so split('.') always gives clean parts.
    // e.g. "sfc.cube-usa.com" → ["sfc", "cube-usa", "com"] → parts[0] = "sfc"
    // e.g. "localhost"        → ["localhost"]               → parts[0] = "localhost"
    const parts = window.location.hostname.split('.');
  
    return parts;
  }

}
